import React from 'react';
import { Lock, Download, ShieldCheck, CreditCard } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800" data-id="element-168">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-169">
        {/* Trust Table / Badges */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12 pb-12 border-b border-slate-800" data-id="element-170">
          <div className="flex flex-col items-center text-center" data-id="element-171">
            <Lock className="w-8 h-8 text-slate-500 mb-3" data-id="element-172" />
            <h4 className="text-white font-bold mb-1" data-id="element-173">Pago Seguro</h4>
            <p className="text-sm" data-id="element-174">Transacción protegida</p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-175">
            <Download className="w-8 h-8 text-slate-500 mb-3" data-id="element-176" />
            <h4 className="text-white font-bold mb-1" data-id="element-177">Descarga Inmediata</h4>
            <p className="text-sm" data-id="element-178">Link al instante</p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-179">
            <ShieldCheck className="w-8 h-8 text-slate-500 mb-3" data-id="element-180" />
            <h4 className="text-white font-bold mb-1" data-id="element-181">Garantía 7 Días</h4>
            <p className="text-sm" data-id="element-182">Sin preguntas</p>
          </div>
          <div className="flex flex-col items-center text-center" data-id="element-183">
            <CreditCard className="w-8 h-8 text-slate-500 mb-3" data-id="element-184" />
            <h4 className="text-white font-bold mb-1" data-id="element-185">Mercado Pago</h4>
            <p className="text-sm" data-id="element-186">Todas las tarjetas</p>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-187">
          <p data-id="element-188">
            © 2024 Mega Pack Aprendizaje Lectura. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-189">
            <a href="#" className="hover:text-white transition-colors" data-id="element-190">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-191">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-192">
              Contacto
            </a>
          </div>
        </div>
      </div>
    </footer>;
}